import * as React from "react";
import { AutoCompleteInput, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';

export function ACTextProperty(title: string, props: string,options:()=>string[]): IUIPropertyDefinition<string> {
    return {
        defaults: props,
        render: (props) => {
            
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    {/* <Label>{title}</Label> */}
                    <AutoCompleteInput
                        options={options()}
                        value={props.uiProps || ''}
                        onChange={s => props.onChange(s)}
                        className="widget-designer-input"
                    />
                </div>
            </div>;
        }
    };
}